import { Box, Chip, Typography } from "@mui/material"
import type { FC } from "react"
import { useFormContext } from "react-hook-form"

import { ADJUSTMENT_TYPE_METADATA } from "../constants"
import type { SelectableAdjustmentType } from "../types"

import { FormSelect } from "@/components/UiKit/FormControls/FormSelect"
import type { Product } from "@/graphql/codegen/graphql"
import type { Option } from "@/types/form-fields"

interface AdjustmentTypeHeaderProps {
  adjustmentType: SelectableAdjustmentType
  product: Product
  warehouseOptions: Option<string>[]
  onWarehouseChange: () => void
}

export const AdjustmentTypeHeader: FC<AdjustmentTypeHeaderProps> = ({
  adjustmentType,
  product,
  warehouseOptions,
  onWarehouseChange,
}) => {
  const { control } = useFormContext<{ warehouseAreaId: string }>()
  const { label, description } = ADJUSTMENT_TYPE_METADATA[adjustmentType]

  return (
    <>
      <Box className='flex items-center gap-x-6 border-b border-gray-200 bg-gray-100 px-10 py-3'>
        <Typography variant='h6' className='shrink-0 font-normal text-gray-800'>
          {label}
        </Typography>
        <Box className='flex items-center gap-x-2'>
          <Typography variant='body2' className='shrink-0 text-gray-700'>
            Product:
          </Typography>
          <Chip label={product.companyProductDescription} size='small' className='rounded-sm bg-gray-300' />
        </Box>
        <Box className='flex flex-1 items-center gap-x-2'>
          <Typography variant='body2' className='shrink-0 text-gray-700'>
            Warehouse:
          </Typography>
          <FormSelect
            control={control}
            name='warehouseAreaId'
            className='max-w-[560px] flex-1'
            options={warehouseOptions}
            onChange={onWarehouseChange}
            data-testid='inventory.adjustment-type-header.warehouse-field'
          />
        </Box>
      </Box>
      <Box className='border-y border-primary bg-primary-100 px-10 py-3'>
        <Typography variant='body2' className='font-medium text-gray-700'>
          {description}
        </Typography>
      </Box>
    </>
  )
}
